<div class="form form__container">
  <div class="form__header">
    <div class="form__label-title">{{ selectedValuableTypeLabel || ('webPos.Closings.ValuablesShort' | translate) }}</div>
  </div>

  <form [formGroup]="closingForm" class="form__content">
    <section class="form__section">
      <div class="form__info-grid">
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Branch' | translate }}</span>
          <span class="form__text">{{ user?.BusinessUnitName }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.RegisterId' | translate }}</span>
          <span class="form__text">{{ user?.SelectedBusinessUnit }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.FullName' | translate }}</span>
          <span class="form__text">{{ user?.DisplayName }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.InventoryDate' | translate }}</span>
          <span class="form__text">{{ currentDate | date:'dd.MM.yyyy HH:mm:ss' }}</span>
        </div>
      </div>
    </section>

    <section class="form__section">
      <div class="form__field">
        <app-dropdown [label]="'webPos.PaymentType' | translate"  [options]="valuableTypes" formControlName="valuableType"  [width]="'300px'">
        </app-dropdown>
      </div>

      @if (denominations.length > 0) {
      <div class="form__tables">
        <table class="form__table">
          <thead>
            <tr>
              <th>{{ 'webPos.Closings.DenominationValue' | translate }} {{ currencyCode | currencymap}}</th>
              <th>{{ 'webPos.Closings.RegisteredCount' | translate }}</th>
              <th>{{ 'webPos.CountOfPieces' | translate }}</th>
              <th>{{ 'webPos.Closings.TotalAmount' | translate }} {{ currencyCode | currencymap}}</th>
            </tr>
          </thead>
          <tbody>
            @for (denomination of denominations; track denomination.value; let i = $index) {
            <tr>
              <td>{{ denomination.value | number }}</td>
              <td>{{ denomination.registeredCount | number }}</td>
              <td>
                <input class="form__input" type="number" min="0" [formControlName]="'denomination_' + denomination.value" appSelectAllOnFocus />
              </td>
              <td>{{ denomination.total | number }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      } @else {
      <div class="form__field">
        <label class="form__label">{{ 'webPos.Closings.TotalValue' | translate }}</label>
        <div class="form__input-group">
          <input
            class="form__input"
            type="number"
            min="0"
            placeholder="0"
            formControlName="summaryValue" />
          <span class="form__input-suffix">{{ currencyCode | currencymap }}</span>
        </div>
      </div>
      }

      <div class="form__summary">
        <div class="form__summary-row">
          <span>{{ 'webPos.Closings.TotalRegisteredValue' | translate }}</span>
          <span class="form__value">{{ totalRegisteredValue | number }} {{ currencyCode | currencymap }}</span>
        </div>
        @if (denominations.length > 0) {
        <div class="form__summary-row">
          <span>{{ 'webPos.Closings.TotalValue' | translate }}</span>
          <span class="form__value">{{ totalValue | number }} {{ currencyCode | currencymap }}</span>
        </div>      
      }
      </div>
    </section>

    
    @if (difference >= 0) {
      <div class="form__summary-row form__summary-row--highlight">
        @if (difference === 0) {
          <span>{{ 'webPos.Closings.Difference' | translate }}</span>
        }
        @if (difference > 0) {
          <span>{{ 'webPos.Closings.Surplus' | translate }}</span>
        }
        <span class="form__value form__value--positive">{{ surplus | number }} {{ currencyCode | currencymap }}</span>
      </div>
    }
    @if (difference < 0) {
      <div class="form__summary-row form__summary-row--highlight form__summary-row--negative">
        <span>{{ 'webPos.Closings.Shortage' | translate }}</span>
        <span class="form__value form__value--negative">{{ shortage | number }} {{ currencyCode | currencymap }}</span>
      </div>
    }
    
   @if (this.closingForm.get('valuableType')?.value) {
    <section class="form__section">
      @if (denominations.length > 0) {
      <p class="form__note">{{ 'webPos.Closings.ValuablesConfirmationNote' | translate }}</p>
      }
     
      <div class="form__footer">
        @if (difference === 0) {
        <div class="form__footer-left">
          <label class="form__checkbox">
            <input type="checkbox" id="confirm" formControlName="confirm" />
            <span>{{ 'webPos.Closings.ConfirmInputsCorrect' | translate }}</span>
          </label>
        </div>
        }
        @if (difference !== 0) {
        <div  class="form__footer-left"></div>
        }
        <div class="form__footer-right">
          @if (difference !== 0) {
          <app-card-button
            [buttonSize]="CardButtonSize.Small"
            [buttonBackground]="CardButtonBackground.Primary"
            [disabled]="false"
            (clicked)="showVoucherExchange(closingForm.get('valuableType')?.value)">
            {{ 'webPos.VoucherExchange.Title' | translate }}
          </app-card-button>
          } 
          @if (difference === 0) {
          <app-card-button
            [buttonSize]="CardButtonSize.Small"
            [buttonBackground]="CardButtonBackground.Primary"
            [disabled]="!closingForm.get('confirm')?.value || difference !== 0"
            (clicked)="confirm(false)">
            {{ 'webPos.Confirm' | translate }}
          </app-card-button>
          }
        </div>
      </div>
      
    </section>
    }
  </form>
</div>

<!-- Voucher exchange dialog for correction -->
<app-voucher-exchange *ngIf="showVoucherExchangeForm" [fromPaymentType]="voucherExchangeFromPaymentType" (onClose)="hideVoucherExchange()"></app-voucher-exchange>